<div class="login-container">
  <div class="login-left"></div>
  <div class="login-right">
    <mat-stepper [linear]="isLinear" #stepper class="login-stepper">
      <mat-step [stepControl]="loginForm">
        <div class="signup-link">
          <p i18n>Don't have an account? <a routerLink="/signup">Signup</a></p>
        </div>
        <div class="login-form">
          <h4 i18n>Welcome to Nabsys Navigator</h4>
          <p i18n>Login to continue</p>
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <app-input
              [formCntlName]="emailMat"
              [inputType]="emailInputType"
              [label]="emailLabel"
              [placeholder]="emailPlaceholder"
              [prefixInputIcon]="mailIcon"
            ></app-input>
            @if (emailMat.hasError('email') && !emailMat.hasError('required')) {
              <mat-error class="error" i18n>Please enter a valid email</mat-error>
            }
            @if (emailMat.hasError('required') && emailMat.touched) {
              <mat-error class="error" i18n>Email is required</mat-error>
            }
            <app-input
              [formCntlName]="password"
              [inputType]="passwordVisibility ? textInputType : passwordInputType"
              [label]="passwordLabel"
              [placeholder]="pswPlaceholder"
              [prefixInputIcon]="lockIcon"
              [suffixInputIcon]="passwordVisibility ? visibilityIcon : visibilityOffIcon"
              [maxLength]="32"
              (inputIconClickEvent)="handlePswdVisibilityCallback($event)"
            ></app-input>
            @if (password.hasError('required') && password.touched) {
              <mat-error class="error" i18n>Password is required</mat-error>
            }
            <div class="remember-forgot">
              <mat-checkbox formControlName="rememberMe" class="remember-me" i18n>
                <span>Remember Me</span>
              </mat-checkbox>
              <a routerLink="/forgot-password" class="forgot-password" i18n> Forgot Password? </a>
            </div>
            <mat-error *ngIf="showErrorMsg" i18n>{{ showErrorMsg }}</mat-error>
            <div class="login-btn">
              <app-button type="submit" class="flow-cta" [fullWidth]="true" [disabled]="loginForm.invalid">
                <span i18n>Login</span>
              </app-button>
            </div>
          </form>
        </div>
      </mat-step>

      <mat-step>
        <div class="login-form">
          <div class="heading">
            <h4 i18n>Check your Mail</h4>
            <p i18n class="mail-check-p">
              We have sent a 6-digit code to <em>{{ verifiedEmail }}</em
              >. Make sure you enter the correct code.
            </p>
          </div>
          <div class="otp">
            <ng-otp-input #otpInput (onInputChange)="onOtpChange($event)" [config]="otpConfig"></ng-otp-input>
          </div>
          <mat-error *ngIf="otpError" class="error" i18n>Wrong code. Try again</mat-error>
          <p class="resend-code">
            <span i18n>Didn't receive code?</span>
            <a (click)="resendOtp()" i18n>Resend Code</a>
          </p>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>
